// extracted by mini-css-extract-plugin
export default {"parameters":"styles_parameters__4Mvno","topN":"styles_topN__6ExCQ"};